<template>
  <!-- daisyUI drives the modal off a checkbox. It is a styling mechanism
    -- with no label and nothing to label it WITH, so it is hidden from
    -- assistive technology and taken out of the tab order rather than
    -- given an invented name: announcing "my-modal, checkbox" to a
    -- screen reader is worse than announcing nothing. -->
  <input type="checkbox" id="my-modal" class="modal-toggle" checked
         aria-hidden="true" tabindex="-1"/>
  <div v-show="uiStore.imageFromInternetModal" class="modal">
    <!-- PROGRESS AND FAILURE, and nothing else.
      -- This used to be where you typed the address: a heading, an input and
      -- three buttons, with the "retrieving" line underneath them. The field
      -- lives under the drop zone now, so the only thing that opens this panel
      -- is prepareFetchImageFromWeb() -- which means it is ALWAYS already
      -- fetching by the time it appears. Leaving a FETCH button on it invited
      -- exactly what happened: a second press on a fetch already running,
      -- reported as "why do I need to press fetch twice".
      --
      -- Close stays. A modal with no way out is a trap, which is the same
      -- reason PdfProgress keeps its cancel. -->
    <div class="modal-box w-11/12 max-w-xl rounded-2xl border border-rule bg-raised
                flex flex-col items-center gap-4 text-center">

      <svg v-show="uiStore.awaitingFetchImage" class="h-10 w-10 animate-spin text-brand"
           viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <circle cx="24" cy="24" r="20" stroke="currentColor" stroke-width="4" class="opacity-20"></circle>
        <path d="M44 24a20 20 0 0 0-20-20" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path>
      </svg>

      <!-- break-all, because these are real addresses: the one this was
        -- reported against was 200 characters of alamy path. -->
      <p v-show="uiStore.awaitingFetchImage" role="status"
         class="text-[15px] break-all leading-snug text-ink-soft">
        {{ t('url.retrieving', { url: uiStore.fetchedImageUrl }) }}
      </p>

      <div v-show="uiStore.fetchedImageError" class="flex flex-col gap-2">
        <p class="text-[15px] font-bold break-all text-error">
          {{ t('url.error', { message: uiStore.fetchedImageError }) }}
        </p>
        <p class="text-[13px] leading-snug text-ink-mute">
          <b>{{ t('url.tip') }}</b> <i>{{ t('url.tipBody') }}</i>
        </p>
      </div>

      <button class="btn btn-sm btn-ghost rounded-lg text-ink-mute"
              @click="uiStore.toggleImageFromInternetModalModal">{{ t('url.close') }}</button>
    </div>
  </div>
</template>

<script>
import { useUiElements } from "./../store/uiElements"
import { useI18n } from "vue-i18n"

export default {
  
  setup() {

    const uiStore = useUiElements()
    const { t } = useI18n()

    return { uiStore, t }
  },
}
</script>
